import React from "react";
import { Table } from "react-bootstrap";
import { isValidArray } from "../../../helper";
import NoDataFound from "../../../component/NoDataFound";
import { LoaderTemplate as DefaultLoader } from "./loaderTemplate";

function TableTemplate({
  isBestPracticesTable = false,
  isRoleTable,
  isGroupTable,
  isUsersTable,
  isLoading = false,
  LoaderTemplate = DefaultLoader,
  headersOptions = [],
  bodyOptions = [],
  headersTemplate,
  tableOptions = {},
  classes = "",
  bodyTemplate
}) {
  return (
    <Table
      responsive
      striped
      hover
      size="sm"
      {...tableOptions}
      className={` ${
        isBestPracticesTable
          ? "best-practices-container"
          : "admin-table-container"
      } ${classes} ${
        isUsersTable === true ? "users-table" : ""
      } table-border-radius`}
    >
      <thead
        className={`no-sort-icon ${
          isUsersTable === true ? "users-table-header" : ""
        }`}
      >
        <tr
          className={`${isGroupTable === true ? "group-table" : ""}${
            isRoleTable === true ? "role-table" : ""
          }`}
        >
          {headersOptions.map((value, index) => {
            return headersTemplate ? headersTemplate(value, index) : null;
          })}
        </tr>
      </thead>
      <tbody
        className={`${isUsersTable === true ? "users-table-body" : ""} ${
          isGroupTable === true ? "group-table" : ""
        } ${isRoleTable === true ? "role-table" : ""}`}
      >
        {isLoading ? (
          LoaderTemplate ? (
            <tr align="center" className="table-loader">
              <td colspan={headersOptions.length}>
                <LoaderTemplate />
              </td>
            </tr>
          ) : (
            <tr align="center">
              <td colspan={headersOptions.length}>Loading...</td>
            </tr>
          )
        ) : isValidArray(bodyOptions) ? (
          bodyOptions.map((value, index) => (
            <tr key={index}>
              {bodyTemplate ? bodyTemplate(value, index) : null}
            </tr>
          ))
        ) : (
          <tr align="center">
            <td colspan={headersOptions.length}>
              <NoDataFound />
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}

export { TableTemplate };
